import React from 'react';

import { IRouter } from '@routers/interface';

export const routerPrivacyPolicy: IRouter = {
  path: '/privacy-policy',
  loader: React.lazy(() => import('./index')),
  exact: true,
  name: 'privacyPolicy.name', //translate here for breadcrumb and sidebar
  masterLayout: false,
};
